import moment from 'moment'


// @ts-expect-error moment locales are not typed
import english from 'moment/dist/locale/en-gb'
// @ts-expect-error moment locales are not typed
import korean from 'moment/dist/locale/ko'
// @ts-expect-error moment locales are not typed
import russian from 'moment/dist/locale/ru'
// @ts-expect-error moment locales are not typed
import japanese from 'moment/dist/locale/ja'
// @ts-expect-error moment locales are not typed
import chineseSimplified from 'moment/dist/locale/zh-cn'
// @ts-expect-error moment locales are not typed
import chineseTaiwanese from 'moment/dist/locale/zh-tw'

// Map language codes to moment locale codes 
const LOCALE_MAP: Record<string, string> = {
  en: 'en',
  ko: 'ko',
  ru: 'ru',
  ja: 'ja',
  zh: 'zh-cn',
  tw: 'zh-tw'
}

// Map language codes to moment locale data
const LOCALE_DATA_MAP: Record<string, any> = {
  en: english,
  ko: korean,
  ru: russian,
  ja: japanese,
  'zh-cn': chineseSimplified,
  'zh-tw': chineseTaiwanese
}

/**
 * Sets the global moment locale
 * @param language The language code (e.g., 'en', 'ko', 'ru')
 * @returns The moment locale that was set
 */
export const setMomentLocale = (language: string): string => {
  const locale = LOCALE_MAP[language] || 'en'

  moment.locale(locale, LOCALE_DATA_MAP[locale])
  return locale
}

/**
 * Gets a localized moment instance
 * @param date The date to format
 * @param language The language code
 * @returns A moment instance with the correct locale
 */
export const localizedMoment = (date: Date | string | number, language: string) => {
  const locale = LOCALE_MAP[language] || 'en'
  return moment(date).locale(locale)
}
